import { render, staticRenderFns } from "./rawMaterialWarehouseMgt.vue?vue&type=template&id=23b15a3f&scoped=true&"
import script from "./rawMaterialWarehouseMgt.vue?vue&type=script&lang=js&"
export * from "./rawMaterialWarehouseMgt.vue?vue&type=script&lang=js&"
import style0 from "./rawMaterialWarehouseMgt.vue?vue&type=style&index=0&id=23b15a3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b15a3f",
  null
  
)

export default component.exports